import React from 'react'

const TodaysAttendance = () => {
  return (
    <div>TodaysAttendance</div>
  )
}

export default TodaysAttendance